import { Typography } from '@global-engineering-shared/gweb-material-ui';
import React from 'react';

import BoldText from 'components/BoldText';
import useStyles from 'features/Events/components/EventsChart/EventsModal/EventsModalTitle/EventsModalTitle.styles';
import { eventColours, EventEnum } from 'features/Events/types/eventData';

type EventsModalTitleProps = {
  event: EventEnum;
};

const EventsModalTitle = ({ event }: EventsModalTitleProps) => {
  const classes = useStyles();

  return (
    <Typography className={classes.title} style={{ color: eventColours[event] }}>
      <BoldText text={event + ' Details'} />
    </Typography>
  );
};

export default EventsModalTitle;
